export const getOptionIds = (options) => options.map(({ id }) => id);
export const excludeOtherFieldValue = ({ listBoxValue, options, }) => {
    const otherFieldValue = deriveOtherFieldValue({ options, listBoxValue });
    if (!otherFieldValue) {
        return listBoxValue;
    }
    const otherFieldValueIdx = listBoxValue.indexOf(otherFieldValue);
    if (otherFieldValueIdx === -1) {
        return listBoxValue;
    }
    return listBoxValue.toSpliced(otherFieldValueIdx, 1);
};
export const deriveOtherFieldValue = ({ listBoxValue, options, }) => {
    const optionIds = getOptionIds(options);
    return listBoxValue.filter((selectedId) => optionIds.indexOf(selectedId) === -1)[0];
};
